import { useEffect } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { AppShell } from "@/components/layout/AppShell";
import { usePowtoonAuth } from "@/lib/auth/PowtoonAuthContext";

export function AppLayout() {
  const { isLoading, isAuthenticated } = usePowtoonAuth();
  const navigate = useNavigate();
  useEffect(() => {
    if (isLoading) return;
    if (!isAuthenticated) navigate("/", { replace: true });
  }, [isLoading, isAuthenticated, navigate]);
  if (isLoading || !isAuthenticated) {
    return (
      <div className="min-h-screen grid place-items-center text-sm text-muted-foreground">
        Loading…
      </div>
    );
  }
  return (
    <AppShell>
      <Outlet />
    </AppShell>
  );
}
